import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  width: 100%;
`;

export const Step = styled.div`
  width: 20%;
  height: 5px;

  background-color: ${({ theme, active }) =>
    active ? theme.colors.primary.blue : theme.colors.neutral.white};
`;
